import React from 'react';

import { Text } from '@mantine/core';

import formatDate from '@/utils/formatDate';

import styles from './cellsV2.module.scss';

interface TransmissionDateCellProps {
  transmissionAt: string | null;
}

export const TransmissionDateCell: React.FC<TransmissionDateCellProps> = ({ transmissionAt }) => (
  <Text className={styles.muted} fz={14}>
    {transmissionAt ? formatDate(transmissionAt, 'MM-DD-YYYY') : '—'}
  </Text>
);
